import { render } from "./FunRunSafetyView.vue?vue&type=template&id=1b8264a8"
import script from "./FunRunSafetyView.vue?vue&type=script&lang=js"
export * from "./FunRunSafetyView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__